export default __webpack_public_path__ + "f4bc487c4fd2b8f3e1a697a3aa941e4c.svg";